var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBoxOpened = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "evkzfyprea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.584314 0 0 0 0 0.231373 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M25.257 10.203l3.694-3.642c.119-.113.174-.275.153-.432-.023-.164-.118-.304-.258-.385L18.882.068c-.207-.117-.465-.08-.634.087l-3.694 3.64-3.695-3.64c-.17-.168-.429-.204-.635-.087L.262 5.744c-.144.081-.24.221-.257.385-.021.157.03.319.146.432l3.696 3.642L.151 13.85c-.115.114-.168.276-.146.432.019.159.113.3.257.382l3.8 2.167v4.718c0 .187.102.357.263.45l9.965 5.675c.08.05.172.069.263.069.09 0 .18-.02.262-.069l9.962-5.675c.161-.094.263-.263.263-.45V16.83l3.804-2.167c.14-.081.235-.223.259-.382.02-.162-.035-.318-.154-.432l-3.692-3.646zm-1.796 0l-8.907 5.075-8.911-5.075 6.68-3.804 2.23-1.267 8.058 4.586.85.485zm-4.755-9.036l9.019 5.14-3.297 3.249-.54-.308-8.48-4.828 3.298-3.253zm-8.306 0L13.7 4.42 4.677 9.556 1.378 6.308 10.4 1.167zM4.677 10.85l9.018 5.14-3.296 3.247L4.85 16.08h-.002l-3.47-1.977 3.298-3.252zm.436 6.578l5.109 2.908c.082.048.174.07.263.07.01 0 .018-.013.03-.013.123-.004.247-.045.341-.137l3.172-3.128v9.2l-8.915-5.081v-3.82zm18.875 3.82l-8.91 5.076V17.13l3.169 3.128c.093.092.213.128.339.137.01 0 .021.013.03.013.092 0 .18-.022.263-.07l5.109-2.908v3.82zm-5.284-2.01l-3.296-3.248 9.02-5.139 3.297 3.252-9.02 5.135z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBoxOpened, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/box-opened.4a89de9a.svg";
export { ForwardRef as ReactComponent };